import actions from './actions';

const initState = {
  roleTemplates: [],
  loading: false,
  error: '',
  lastUpdated: null,
};

export default function roleTemplatesReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_ROLE_TEMPLATES:
    case actions.CREATE_ROLE_TEMPLATE:
    case actions.UPDATE_ROLE_TEMPLATE:
    case actions.DELETE_ROLE_TEMPLATE:
      return {
        ...state,
        loading: true,
        error: '',
      };

    case actions.GET_ROLE_TEMPLATES_SUCCESS:
      return {
        ...state,
        roleTemplates: action.roleTemplates,
        loading: false,
        error: '',
        lastUpdated: new Date().toISOString(),
      };

    case actions.CREATE_ROLE_TEMPLATE_SUCCESS:
      return {
        ...state,
        roleTemplates: [...state.roleTemplates, action.roleTemplate],
        loading: false,
        error: '',
      };

    case actions.UPDATE_ROLE_TEMPLATE_SUCCESS:
      return {
        ...state,
        roleTemplates: state.roleTemplates.map(template =>
          template.id === action.roleTemplate.id ? action.roleTemplate : template
        ),
        loading: false,
        error: '',
      };

    case actions.DELETE_ROLE_TEMPLATE_SUCCESS:
      return {
        ...state,
        roleTemplates: state.roleTemplates.filter(template => template.id !== action.templateId),
        loading: false,
        error: '',
      };

    case actions.GET_ROLE_TEMPLATES_ERROR:
    case actions.CREATE_ROLE_TEMPLATE_ERROR:
    case actions.UPDATE_ROLE_TEMPLATE_ERROR:
    case actions.DELETE_ROLE_TEMPLATE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case actions.CLEAR_ROLE_TEMPLATES_ERROR:
      return {
        ...state,
        error: '',
      };

    default:
      return state;
  }
}
